import { render, staticRenderFns } from "./welComeCommonFun.vue?vue&type=template&id=74650471&scoped=true&"
import script from "./welComeCommonFun.vue?vue&type=script&lang=ts&"
export * from "./welComeCommonFun.vue?vue&type=script&lang=ts&"
import style0 from "./welComeCommonFun.vue?vue&type=style&index=0&id=74650471&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74650471",
  null
  
)

export default component.exports